import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectAppState } from './app-state.selector.ts';
import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';
import { selectCurrentStory } from './current-story.selector.ts';

export const selectAnimationPrerequisites = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  selectCurrentStory,
  selectAppState,
  (state: RootState) => state.storyReading.keyWordPositions,
  ({ task, step }, currentStory, appState, keyWordPositions) => {
    const storyIndex = step.index ?? 0;

    return {
      task,
      step,
      currentStory: currentStory ? { lines: currentStory.lines } : null,
      keyWordPositions,
      appState,
      currentSentence: task.story ? task.story[storyIndex] : null,
    };
  }
);
